import api from "./api";

export type DeleteUserDto = {
  id: number | string;
};
export interface createEditUserDto {
  roleId?: number;
  fullName?: string;
  userName?: string;
  password?: string;
  email?: string;
  image?: null;
  prefferedLanguage?: string;
  prefferedMode?: string;
  isActive?: boolean;
  isComplex?: boolean;
}
export interface userInfo {
  id: number;
  password: string;
}
export const getUsers = async (
  q: string,
  limit: number,
  isActive?: boolean
) => {
  let url = `/users?q=${q}&limit=${limit.toString()}`;

  if (isActive !== undefined) {
    url += `&isActive=${isActive}`;
  }

  return await api.get(url);
};
export const deleteUser = async (dto: DeleteUserDto) => {
  return await api.delete(`/users/${dto.id}`);
};
export const getUserById = async (userId: string | undefined) => {
  return await api.get(`/users/${userId}`);
};
export const createUser = async (userDetails: createEditUserDto) => {
  return await api.post("/users", userDetails);
};
export const editUser = async (userId: any, body: createEditUserDto) => {
  return await api.put(`/users/${userId}`, body);
};

export const changeUserPassword = async ({ currentPassword, newPassword, isComplex }: { currentPassword: string, newPassword: string, isComplex: boolean }) => {
  return await api.post(`/users/change-password`, {
    currentPassword,
    newPassword,
    isComplex
  });
};

export const changeUserPasswordAdmin = async ({ id, newPassword, isComplex }: { id: number | undefined, newPassword: string, isComplex: boolean }) => {
  return await api.post(`/users/${id}/reset-password`, {
    newPassword,
    isComplex
  });
};
